// Core
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

// Accets
import { apiService } from 'services/ApiService';
import { getInitials, formatDateWithSuffix, validateLoadMore, parseNotifyDate } from 'services/Utils';
import { ReactComponent as TransactionIcon } from 'assets/svg/transaction-history-3.svg';
import { ReactComponent as EmptyListNotifications } from 'assets/svg/empty-list-notifications.svg';

// Components
import Card from 'components/Card/Card';
import Balance from './components/Balance';
import Transactions from './components/Transactions';

const Wallet = ({ userData }) => {
	return (
		<>
			<Balance userData={userData} />
			<Transactions userData={userData} />
		</>
	);
};

export default Wallet;